import angular from 'angular';
const PRIVILEGES = {
  r: 1, //Read
  u: 2, //Update
  c: 4, //Create
  d: 8, //Delete
  e: 16, //Execute
  s: 32, //Syneton
  a: 15, //All crud actions
};
const FUNCTIONALITIES = [
  {
    key: 1,
    name: 'Relation',
  },
  {
    key: 2,
    name: 'RegistrationOwn',
  },
  {
    key: 4,
    name: 'RegistrationOthers',
  },
  {
    key: 8,
    name: 'Pricelist',
  },
  {
    key: 16,
    name: 'InvoiceDraft',
  },
  {
    key: 32,
    name: 'InvoiceFinal',
  },
  {
    key: 64,
    name: 'CompanyOwn',
  },
  {
    key: 128,
    name: 'Settings',
  },
  {
    key: 256,
    name: 'TaskTemplates',
  },
  {
    key: 512,
    name: 'InvoiceTransactions',
  },
  {
    key: 1024,
    name: 'Documents',
  },
  {
    key: 2048,
    name: 'Users',
  },
  {
    key: 4096,
    name: 'RentabilityReport',
  },
  {
    key: 8192,
    name: 'Tags',
  },
  {
    key: 16384,
    name: 'InteractionsOwn',
  },
  {
    key: 32768,
    name: 'InteractionsOthers',
  },
  {
    key: 65536,
    name: 'TaskSchedules',
  },
  {
    key: 131072,
    name: 'PlannedTask',
  },
  {
    key: 262144,
    name: 'Todo',
  },
  {
    key: 524288,
    name: 'IntraCompanyInvoice',
  },
  {
    key: 1048576,
    name: 'FreeInvoiceCreditNote',
  },
  {
    key: 2097152,
    name: 'RegistrationsPerReports',
  },
  {
    key: 4194304,
    name: 'AbsenceReports',
  },
  {
    key: 8388608,
    name: 'ChecklistInvoicingReport',
  },
  {
    key: 16777216,
    name: 'AbsenceAndCounters',
  },
  {
    key: 33554432,
    name: 'Teams',
  },
  {
    key: 67108864,
    name: 'EmployeeInternalPrice',
  },
  {
    key: 134217728,
    name: 'BudgetHours',
  },
  {
    key: 268435456,
    name: 'TrainingManagement',
  },
  {
    key: 536870912,
    name: 'BudgetAmounts',
  },
  {
    key: 1073741824,
    name: 'CapacityPlanning',
  },
  {
    key: 2147483648,
    name: 'AI',
  },
];
angular.module('cloudX').factory('checkSecurity', [
  'authService',
  function(authService) {
    var parseSecurityPrivileges = function(item) {
      var idx = item.lastIndexOf(':');
      if (idx < 0)
        return {
          name: item,
          value: PRIVILEGES.a,
        };
      var name = item.substr(0, idx);
      var perm = item.substr(idx + 1);
      if (perm.length === 0)
        return {
          name: name,
          value: PRIVILEGES.a,
        };
      if (!isNaN(perm))
        return {
          name: name,
          value: parseInt(perm),
        };
      return {
        name: name,
        value: perm.split('').reduce(function(s, p) {
          // eslint-disable-next-line no-bitwise
          if (PRIVILEGES.hasOwnProperty(p.toLowerCase())) return PRIVILEGES[p.toLowerCase()] | s;
          return s;
        }, 0),
      };
    };

    var parseSecurityParam = function(value) {
      if (typeof value === 'undefined' || value === null) return {};
      var perm;
      var security = {
        $parsed: true,
      };
      if (angular.isArray(value)) {
        /* Allowed array formats:
          ['RegistrationOwn','RegistrationOthers']
          ['RegistrationOwn:15','RegistrationOthers:1']
          ['RegistrationOwn:a','RegistrationOthers:rc']
      */
        return value.reduce(
          function(sec, item) {
            perm = parseSecurityPrivileges(item);
            sec[perm.name] = perm.value;
            return sec;
          },
          {
            $parsed: true,
          },
        );
      } else if (angular.isObject(value)) {
        /* Allowed object formats:
          {RegistrationOwn:15,RegistrationOthers:1}
          {RegistrationOwn:'a',RegistrationOthers:'r'}
          {RegistrationOwn:'',RegistrationOthers:''}
      */
        if (value.$parsed) return value;
        for (var prop in value) {
          if (value.hasOwnProperty(prop)) {
            perm = parseSecurityPrivileges(prop + ':' + value[prop]);
            security[perm.name] = perm.value;
          }
        }
      } else if (angular.isString(value)) {
        /* Allowed string formats:
          'RegistrationOwn:15'
          'RegistrationOwn:a'
      */
        perm = parseSecurityPrivileges(value);
        security[perm.name] = perm.value;
      }

      return security;
    };

    var parsePermissions = function(permissionString) {
      var perms = permissionString.split(';');
      var result = {};
      for (var i = 0; i < perms.length; i++) {
        var permission = perms[i].split(':');
        if (permission.length !== 2) continue;
        var functionalities = permission[0];
        var privilege = permission[1];

        for (var j = 0; j < FUNCTIONALITIES.length; j++) {
          if (Math.floor(functionalities / FUNCTIONALITIES[j].key) % 2 !== 0)
            // eslint-disable-next-line no-bitwise
            result[FUNCTIONALITIES[j].name] = (result[FUNCTIONALITIES[j].name] || 0) | privilege;
        }
      }
      return result;
    };

    var service = function(param) {
      var auth = authService.getClaims();
      if (!auth) return false;
      var security = parseSecurityParam(param);
      var permissions = {};
      try {
        permissions = parsePermissions(auth.Role);
      } catch (ex) {
        permissions = {};
      }
      for (var prop in security) {
        if (security.hasOwnProperty(prop)) {
          var reqPerm = security[prop];
          if (auth.su && prop.toLowerCase() === 'support') return true;
          var perm = permissions[prop] || 0;
          // eslint-disable-next-line no-bitwise
          if (reqPerm & perm) return true;
        }
      }
      return false;
    };

    service.parse = parseSecurityParam;

    return service;
  },
]);
